import React from 'react';
import { useTranslation } from 'react-i18next';
import TextArea from 'src/ui/wf/common/textArea/TextArea';
import {
  WfRecoveryStatus,
  WfRecoveryStatusMapping,
  getRecoveryStatusOptions,
} from 'src/api/wf/models/enums/WfRecoveryStatus';
import { FormState } from './hooks';
import { FormRow } from '../../form/FormRow';
import DropdownSelect from '../../select/DropdownSelect';

interface WorkRequestFormProps {
  formState: FormState;
  onFieldChange: <K extends keyof FormState>(field: K, value: FormState[K]) => void;
}

export const WorkRequestForm = ({ formState, onFieldChange }: WorkRequestFormProps) => {
  const { t } = useTranslation();

  const workSubmissionStatusOptions = [
    { title: '', value: '' },
    { title: t('wf.statusInformationRegistration.submitted'), value: 'submitted' },
    { title: t('wf.statusInformationRegistration.notSubmitted'), value: 'not submitted' },
  ];

  return (
    <div>
      <div className="mb-3">
        <FormRow title={t('wf.statusInformationRegistration.responseInput')}>
          <div>
            <DropdownSelect
              selectedValue={
                WfRecoveryStatusMapping(t)[formState.responseInput as WfRecoveryStatus]
              }
              optionValues={getRecoveryStatusOptions(t)}
              onChange={(event) =>
                onFieldChange('responseInput', event.target.value as WfRecoveryStatus)
              }
            />
            <p className="mt-1 text-xs text-gray-500">
              {t('wf.statusInformationRegistration.responseInputNote')}
            </p>
          </div>
        </FormRow>
      </div>

      <div className="block space-y-2 border bg-gray-100 p-2">
        <h3 className="mb-4 block text-lg font-semibold">
          {t('wf.statusInformationRegistration.workRequestForm')}
        </h3>
        <FormRow title={t('wf.statusInformationRegistration.workSubmissionStatus')}>
          <DropdownSelect
            selectedValue={workSubmissionStatusOptions.find(
              // formState.workSubmissionStatus==undefinedのテストケースを追加してください。
              (state) => state.value === (formState.workSubmissionStatus ?? '')
            )}
            optionValues={workSubmissionStatusOptions}
            onChange={(event) => onFieldChange('workSubmissionStatus', event.target.value)}
          />
        </FormRow>

        <FormRow title={t('wf.statusInformationRegistration.workRemarks')}>
          <TextArea
            value={formState.workRemarks ?? ''}
            onChange={(val) => onFieldChange('workRemarks', val)}
            rows={3}
          />
        </FormRow>
      </div>
    </div>
  );
};

export default WorkRequestForm;
